import { render, staticRenderFns } from "./AutoInput.vue?vue&type=template&id=3b663338&scoped=true"
import script from "./AutoInput.vue?vue&type=script&lang=js"
export * from "./AutoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b663338",
  null
  
)

export default component.exports